export default __webpack_public_path__ + "no_pic.png";